export const constants = {
	selector: {
		target: 'data-showmore',
		fullText: 'data-read-more-full-text',
		showMoreText: 'data-read-more-text',
		showLessText: 'data-read-less-text',
	},
}
